import { getCircleSize } from "../../SvgOverlay/utils";
import type { FindClickedRoute } from "./types";

const DIRECT_HIT_DISTANCE_SQUARED = 0.001;

export const findClickedRoute: FindClickedRoute = ({
  paths,
  planX,
  planY,
  zoomLevel,
  circleSizeScale,
}) => {
  const markerRadius = (getCircleSize(zoomLevel) * circleSizeScale) / 2;
  const markerRadiusSquared = markerRadius * markerRadius;

  for (const path of paths) {
    if (path.waypoints.length === 0) continue;
    const lastWaypoint = path.waypoints[path.waypoints.length - 1];
    const markerDeltaX = planX - lastWaypoint.x;
    const markerDeltaY = planY - lastWaypoint.y;
    if (
      markerDeltaX * markerDeltaX + markerDeltaY * markerDeltaY <=
      markerRadiusSquared
    ) {
      return path.routeId;
    }
  }

  const lineThreshold = markerRadius;
  const lineThresholdSquared = lineThreshold * lineThreshold;
  let bestRouteId: string | null = null;
  let bestDistanceSquared = lineThresholdSquared;

  for (const path of paths) {
    if (path.waypoints.length < 2) continue;

    const { coordinateExtents } = path;
    if (planX < coordinateExtents.minX - lineThreshold) continue;
    if (planX > coordinateExtents.maxX + lineThreshold) continue;
    if (planY < coordinateExtents.minY - lineThreshold) continue;
    if (planY > coordinateExtents.maxY + lineThreshold) continue;

    const waypoints = path.waypoints;
    for (let i = 0; i < waypoints.length - 1; i++) {
      const segmentStart = waypoints[i];
      const segmentEnd = waypoints[i + 1];
      const segmentDeltaX = segmentEnd.x - segmentStart.x;
      const segmentDeltaY = segmentEnd.y - segmentStart.y;
      const segmentLengthSquared =
        segmentDeltaX * segmentDeltaX + segmentDeltaY * segmentDeltaY;

      let projectionFactor = 0;
      if (segmentLengthSquared > 0) {
        projectionFactor =
          ((planX - segmentStart.x) * segmentDeltaX +
            (planY - segmentStart.y) * segmentDeltaY) /
          segmentLengthSquared;
        if (projectionFactor < 0) projectionFactor = 0;
        else if (projectionFactor > 1) projectionFactor = 1;
      }

      const projectionX = segmentStart.x + projectionFactor * segmentDeltaX;
      const projectionY = segmentStart.y + projectionFactor * segmentDeltaY;
      const distanceDeltaX = planX - projectionX;
      const distanceDeltaY = planY - projectionY;
      const distanceSquared =
        distanceDeltaX * distanceDeltaX + distanceDeltaY * distanceDeltaY;

      if (distanceSquared < bestDistanceSquared) {
        bestDistanceSquared = distanceSquared;
        bestRouteId = path.routeId;
        if (distanceSquared < DIRECT_HIT_DISTANCE_SQUARED) return bestRouteId;
      }
    }
  }

  return bestRouteId;
};
